export default __webpack_public_path__ + "static/media/ic_openocean.4434394c.svg";